import { ReactComponent as IconStar } from "assets/images/icons/star.svg";
import Panel from "pages/Dashboard/Panel";
import UserDetail from "components/ui/UserDetail/UserDetail";
import Button from "components/ui/Button/Button";
import { useHistory } from "react-router-dom";
import useViewData from "features/view/hooks/useViewData";
import Loader from "components/ui/Loader/Loader";
import Alert from "components/ui/Alert/Alert";
import "pages/Dashboard/FavoritesPanel.scss";

function FavoritesPanel() {
  const { view, isLoading } = useViewData('favorites/profile/startpage');
  const history = useHistory();

  let content = <Loader containerVariant={ 'center' }/>;
  if (!isLoading) {
    if (view) {
      content = view.map((item) => <UserDetail key={ item.nid }
                                               username={ item.title }
                                               image={ item.field_profile_photo }
                                               subtext={ item.field_profile_city }
                                               url={ item.view_node }
                                               marginBottom={ true }/>);
      if (view.length === 0) {
        content = <>U heeft nog geen favoriete leden opgeslagen.</>;
      }
    } else {
      content = <Alert message={ `Het ophalen van uw favorieten is mislukt.` }/>;
    }
  }

  return (
    <Panel title={ 'Favoriete leden' }
           id={ 'favorites' }
           showAllPath={ '/leden/favorieten' }
           linkLabel={ 'Alle favorieten' }
           icon={ <IconStar/> }
           hasContentBackground={ true }>
      <div className={ 'favorites-panel' }>
        <div className={ 'favorites-panel__users' }>
          { content }
        </div>

        <div className={'favorites-panel__button'}>
          <Button variant={ 'secondary' } onClick={ () => history.push('/leden') }
                  className={ 'button--full-width' }>
            Leden zoeken
          </Button>
        </div>
      </div>
    </Panel>
  );
}

export default FavoritesPanel;
